import * as PIXI from 'pixi.js';
import gsap from "gsap";
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import LocaleManager from '../components/LocaleManager';
import { GameConfig } from '../utils/GameConfig';
import Tools from '../utils/Tools';
import Skin from './Skin';
import config from 'config';

export default class SkinShop extends PIXI.Container {
    constructor() {
        super();

        ////////// Elements in the scene
        // Button for opening the skin shop
        this.buttonOpenSkinShop = null;
        // Alert icon for a available purchase
        this.alertSkinShop = null;

        // Skin shop container
        this.skinShopContainer = null;
        // Background of the skin shop
        this.skinShopBackground = null;
        // Button for closing the skin shop
        this.buttonCloseSkinShop = null;
        // Button for swiching left
        this.leftButton = null;
        // Button for swiching right
        this.rightButton = null;
        // The background of rarity selection
        this.rarityBackground = null;
        // The rarity button for selection
        this.rarityButton = null;
        // The text on the rarity button
        this.rarityText = null;
        // The rarity tab list
        this.rarityTabList = [
            { positionX: -90, text: "BASIC", tabContainer: this.basicSkinContainer },
            { positionX: 0, text: "RARE", tabContainer: this.rareSkinContainer },
            { positionX: 90, text: "FUNKY", tabContainer: this.funkySkinContainer },
        ];

        this.rarityTabIndex = 0;

        // The container of the basic skin
        this.basicSkinContainer = null;
        // List of basic skin
        this.basicSkinList = [];
        // List of unpurchased basic skin
        this.basicSkinUnpurchasedList = [];
        // The purchase price of the basic skin
        this.basicSkinPurchasePrice = 100;
        this.basicSkinPriceText = null;
        // The basic skin purchase button
        this.basicSkinPurchaseButton = null;
        // The basic skin watch ad button
        this.basicSkinWatchAdButton = null;

        // The container of the rare skin
        this.rareSkinContainer = null;
        // List of rare skin
        this.rareSkinList = [];
        // List of unpurchased rare skin
        this.rareSkinUnpurchasedList = [];
        // The purchase price of the basic skin
        this.rareSkinPurchasePrice = 100;
        this.rareSkinPriceText = null;
        // The rare skin purchase button
        this.rareSkinPurchaseButton = null;
        // The rare skin watch ad button
        this.rareSkinWatchAdButton = null;
        this.lockRVButton = false;

        // The container of the funky skin
        this.funkySkinContainer = null;
        // List of funky skin
        this.funkySkinList = [];
        // List of unpurchased funky skin
        this.funkySkinUnpurchasedList = [];
        // The funky skin watch ad button
        this.funkySkinWatchAdButton = null;



        ////////// Parameters
        // True if the skin shop is opened
        this.isSkinShopOpen = false;

        // Height of the skin shop
        this.skinShopHeight = 534;

        ////////// Bind event handlers
        // Bind all the click events
        this.onClickOpenSkinShop = this.onClickOpenSkinShop.bind(this);
        this.onClickCloseSkinShop = this.onClickCloseSkinShop.bind(this);
        this.onClickLeftButton = this.onClickLeftButton.bind(this);
        this.onClickRightButton = this.onClickRightButton.bind(this);
        this.onClickBasicPurchase = this.onClickBasicPurchase.bind(this);
        this.onClickRarePurchase = this.onClickRarePurchase.bind(this);
        this.onClickWatchAdAddCoin = this.onClickWatchAdAddCoin.bind(this);
        this.onClickWatchAdFunky = this.onClickWatchAdFunky.bind(this);
        // this.onClickEpicPurchase = this.onClickEpicPurchase.bind(this);
        // this.onClickChestPurchase = this.onClickChestPurchase.bind(this);

        this.updateRarityButton = this.updateRarityButton.bind(this);

        this.initSkinShop();
    }

    initSkinShop() {

        const decalX = 85;

        // Initialize the button to open skin shop
        const buttonSkinTexture = AssetsManager.texturesPixi.buttonSkin;
        this.buttonOpenSkinShop = new PIXI.Sprite(buttonSkinTexture);
        this.buttonOpenSkinShop.interactive = true;
        this.buttonOpenSkinShop.buttonMode = true;
        this.buttonOpenSkinShop.on("pointerdown", this.onClickOpenSkinShop);
        this.buttonOpenSkinShop.scale.set(0.3);
        this.buttonOpenSkinShop.anchor.set(1, 1);
        this.addChild(this.buttonOpenSkinShop);

        // Initialize the alert icon
        const alertTexture = AssetsManager.texturesPixi.alertIcon;
        this.alertSkinShop = new PIXI.Sprite(alertTexture);
        this.alertSkinShop.scale.set(2);
        this.alertSkinShop.anchor.set(0.5);
        this.alertSkinShop.position.set(-190, -190);
        this.alertSkinShop.visible = false;
        this.buttonOpenSkinShop.addChild(this.alertSkinShop);

        // Initialize the skin shop container
        this.skinShopContainer = new PIXI.Container();
        this.addChild(this.skinShopContainer);

        // Initialize the skin shop background
        const skinShopBackgroundTexture = AssetsManager.texturesPixi.skinShopBackground;
        this.skinShopBackground = new PIXI.Sprite(skinShopBackgroundTexture);
        this.skinShopContainer.addChild(this.skinShopBackground);
        this.skinShopBackground.anchor.set(0.5, 1);

        // Initialize the close button
        const buttonCloseSkinShopTexture = AssetsManager.texturesPixi.skinShopClose;
        this.buttonCloseSkinShop = new PIXI.Sprite(buttonCloseSkinShopTexture);
        this.buttonCloseSkinShop.interactive = true;
        this.buttonCloseSkinShop.buttonMode = true;
        this.buttonCloseSkinShop.on("pointerdown", this.onClickCloseSkinShop);
        this.buttonCloseSkinShop.scale.set(0.4);
        this.buttonCloseSkinShop.anchor.set(1, 1);
        this.skinShopContainer.addChild(this.buttonCloseSkinShop);

        // Initialize the left button
        const leftButtonTexture = AssetsManager.texturesPixi.leftButton;
        this.leftButton = new PIXI.Sprite(leftButtonTexture);
        this.leftButton.interactive = true;
        this.leftButton.buttonMode = true;
        this.leftButton.on("pointerdown", this.onClickLeftButton);
        this.leftButton.scale.set(0.18);
        this.leftButton.anchor.set(1, 0);
        this.skinShopContainer.addChild(this.leftButton);

        // Initialize the right button
        const rightButtonTexture = AssetsManager.texturesPixi.rightButton;
        this.rightButton = new PIXI.Sprite(rightButtonTexture);
        this.rightButton.interactive = true;
        this.rightButton.buttonMode = true;
        this.rightButton.on("pointerdown", this.onClickRightButton);
        this.rightButton.scale.set(0.18);
        this.rightButton.anchor.set(0, 0);
        this.skinShopContainer.addChild(this.rightButton);

        // Initialize the rarity background
        const rarityBackgroundTexture = AssetsManager.texturesPixi.rarityBackground;
        this.rarityBackground = new PIXI.Sprite(rarityBackgroundTexture);
        this.rarityBackground.anchor.set(0.5);
        this.rarityBackground.width = 270;
        this.skinShopContainer.addChild(this.rarityBackground);

        const rarityStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 20,
            fill: '#a7a6a7',
        });

        var basicText = new PIXI.Text("BASIC", rarityStyle);
        basicText.anchor.set(0.5);
        basicText.x = this.rarityTabList[0].positionX;
        this.rarityBackground.addChild(basicText);

        var rareText = new PIXI.Text("RARE", rarityStyle);
        rareText.anchor.set(0.5);
        rareText.x = this.rarityTabList[1].positionX;
        this.rarityBackground.addChild(rareText);

        var funkyText = new PIXI.Text("FUNKY", rarityStyle);
        funkyText.anchor.set(0.5);
        funkyText.x = this.rarityTabList[2].positionX;
        this.rarityBackground.addChild(funkyText);

        // Initialize the rarity button
        const rarityButtonTexture = AssetsManager.texturesPixi.orangeButton;
        this.rarityButton = new PIXI.Sprite(rarityButtonTexture);
        this.rarityButton.scale.set(0.35, 0.35);
        this.rarityButton.anchor.set(0.5);
        this.rarityButton.x = this.rarityTabList[0].positionX;
        this.rarityBackground.addChild(this.rarityButton);

        const rarityButtonStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 20,
            fill: '#ffffff',
        });

        this.rarityText = new PIXI.Text(this.rarityTabList[0].text, rarityButtonStyle);
        this.rarityText.anchor.set(0.5);
        this.rarityText.x = this.rarityTabList[0].positionX;
        this.rarityBackground.addChild(this.rarityText);

        // Load some texture and text for the skin page
        this.blueButtonTexture = AssetsManager.texturesPixi.blueButton;
        this.greyButtonTexture = AssetsManager.texturesPixi.greyButton;
        const blueButtonTexture = AssetsManager.texturesPixi.blueButton;
        const greenButtonTexture = AssetsManager.texturesPixi.greenButton;
        const coinGoldTexture = AssetsManager.texturesPixi.coinsGold;
        const playIconTexture = AssetsManager.texturesPixi.playIcon;
        const skinButtonStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 25,
            fill: '#ffffff',
        });
        const funkySkinButtonStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 18,
            fill: '#ffffff',
        });
        const explicationTextStyle = new PIXI.TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 12,
            fill: '#a7a6a7',
        });

        // Initialize the basic skins
        this.basicSkinContainer = new PIXI.Container();

        this.skinShopContainer.addChild(this.basicSkinContainer);
        const basicSkinList = GameConfig.basicSkinList;
        for (let index = 0; index < basicSkinList.length; index++) {
            const basicSkin = basicSkinList[index];
            const skinName = basicSkin.name;
            const skinIndex = index;
            const skinContainer = this.basicSkinContainer;

            var skin = new Skin(skinName, skinIndex, skinContainer);
            this.basicSkinList.push(skin);
        }

        var basicExplicationText = new PIXI.Text(LocaleManager.words.basicTutorial, explicationTextStyle);
        basicExplicationText.anchor.set(0.5, 1);
        basicExplicationText.x = 0;
        basicExplicationText.y = -130;
        this.basicSkinContainer.addChild(basicExplicationText);

        this.basicSkinPurchaseButton = new PIXI.Sprite(blueButtonTexture);
        this.basicSkinPurchaseButton.interactive = true;
        this.basicSkinPurchaseButton.buttonMode = true;
        this.basicSkinPurchaseButton.on("pointerdown", this.onClickBasicPurchase);
        this.basicSkinPurchaseButton.scale.set(0.5, 0.35);
        this.basicSkinPurchaseButton.anchor.set(1, 1);
        this.basicSkinPurchaseButton.x = -20;
        this.basicSkinPurchaseButton.y = -50;
        this.basicSkinContainer.addChild(this.basicSkinPurchaseButton);

        this.basicSkinPriceText = new PIXI.Text(this.basicSkinPurchasePrice, skinButtonStyle);
        this.basicSkinPriceText.anchor.set(1, 1);
        this.basicSkinPriceText.x = -65;
        this.basicSkinPriceText.y = -80;
        this.basicSkinContainer.addChild(this.basicSkinPriceText);

        var coinIcon = new PIXI.Sprite(coinGoldTexture);
        coinIcon.scale.set(0.13);
        coinIcon.anchor.set(1, 1);
        coinIcon.x = -30;
        coinIcon.y = -80;
        this.basicSkinContainer.addChild(coinIcon);

        this.basicSkinWatchAdButton = new PIXI.Sprite(greenButtonTexture);
        this.basicSkinWatchAdButton.interactive = true;
        this.basicSkinWatchAdButton.buttonMode = true;
        this.basicSkinWatchAdButton.on("pointerdown", this.onClickWatchAdAddCoin);
        this.basicSkinWatchAdButton.scale.set(0.5, 0.35);
        this.basicSkinWatchAdButton.anchor.set(0, 1);
        this.basicSkinWatchAdButton.x = 20;
        this.basicSkinWatchAdButton.y = -50;
        this.basicSkinContainer.addChild(this.basicSkinWatchAdButton);

        var playIcon = new PIXI.Sprite(playIconTexture);
        playIcon.scale.set(0.05);
        playIcon.anchor.set(0, 1);
        playIcon.x = 75;
        playIcon.y = -75;
        this.basicSkinContainer.addChild(playIcon);

        var text = new PIXI.Text("+500", skinButtonStyle);
        text.anchor.set(0, 1);
        text.x = 40;
        text.y = -85;
        this.basicSkinContainer.addChild(text);

        var coinIcon = new PIXI.Sprite(coinGoldTexture);
        coinIcon.scale.set(0.13);
        coinIcon.anchor.set(0, 1);
        coinIcon.x = 110;
        coinIcon.y = -80;
        this.basicSkinContainer.addChild(coinIcon);

        this.rarityTabList[0].tabContainer = this.basicSkinContainer;

        // Initialize the rare skins
        this.rareSkinContainer = new PIXI.Container();

        this.skinShopContainer.addChild(this.rareSkinContainer);
        const rareSkinList = GameConfig.rareSkinList;
        for (let index = 0; index < rareSkinList.length; index++) {
            const rareSkin = rareSkinList[index];
            const skinName = rareSkin.name;
            const skinIndex = index;
            const skinContainer = this.rareSkinContainer;

            var skin = new Skin(skinName, skinIndex, skinContainer);
            this.rareSkinList.push(skin);
        }

        var rareExplicationText = new PIXI.Text(LocaleManager.words.rareTutorial, explicationTextStyle);
        rareExplicationText.anchor.set(0.5, 1);
        rareExplicationText.x = 0;
        rareExplicationText.y = -130;
        this.rareSkinContainer.addChild(rareExplicationText);

        this.rareSkinPurchaseButton = new PIXI.Sprite(blueButtonTexture);
        this.rareSkinPurchaseButton.interactive = true;
        this.rareSkinPurchaseButton.buttonMode = true;
        this.rareSkinPurchaseButton.on("pointerdown", this.onClickRarePurchase);
        this.rareSkinPurchaseButton.scale.set(0.5, 0.35);
        this.rareSkinPurchaseButton.anchor.set(1, 1);
        this.rareSkinPurchaseButton.x = -20;
        this.rareSkinPurchaseButton.y = -50;
        this.rareSkinContainer.addChild(this.rareSkinPurchaseButton);

        this.rareSkinPriceText = new PIXI.Text(this.rareSkinPurchasePrice, skinButtonStyle);
        this.rareSkinPriceText.anchor.set(1, 1);
        this.rareSkinPriceText.x = -65;
        this.rareSkinPriceText.y = -80;
        this.rareSkinContainer.addChild(this.rareSkinPriceText);

        var coinIcon = new PIXI.Sprite(coinGoldTexture);
        coinIcon.scale.set(0.13);
        coinIcon.anchor.set(1, 1);
        coinIcon.x = -30;
        coinIcon.y = -80;
        this.rareSkinContainer.addChild(coinIcon);

        this.rareSkinWatchAdButton = new PIXI.Sprite(greenButtonTexture);
        this.rareSkinWatchAdButton.interactive = true;
        this.rareSkinWatchAdButton.buttonMode = true;
        this.rareSkinWatchAdButton.on("pointerdown", this.onClickWatchAdAddCoin);
        this.rareSkinWatchAdButton.scale.set(0.5, 0.35);
        this.rareSkinWatchAdButton.anchor.set(0, 1);
        this.rareSkinWatchAdButton.x = 20;
        this.rareSkinWatchAdButton.y = -50;
        this.rareSkinContainer.addChild(this.rareSkinWatchAdButton);

        var playIcon = new PIXI.Sprite(playIconTexture);
        playIcon.scale.set(0.05);
        playIcon.anchor.set(0, 1);
        playIcon.x = 75;
        playIcon.y = -75;
        this.rareSkinContainer.addChild(playIcon);

        var text = new PIXI.Text("+500", skinButtonStyle);
        text.anchor.set(0, 1);
        text.x = 40;
        text.y = -85;
        this.rareSkinContainer.addChild(text);

        var coinIcon = new PIXI.Sprite(coinGoldTexture);
        coinIcon.scale.set(0.13);
        coinIcon.anchor.set(0, 1);
        coinIcon.x = 110;
        coinIcon.y = -80;
        this.rareSkinContainer.addChild(coinIcon);

        this.rarityTabList[1].tabContainer = this.rareSkinContainer;

        // Initialize the funky skins
        this.funkySkinContainer = new PIXI.Container();

        this.skinShopContainer.addChild(this.funkySkinContainer);

        const funkySkinList = GameConfig.funkySkinList;
        for (let index = 0; index < funkySkinList.length; index++) {
            const funkySkin = funkySkinList[index];
            const skinName = funkySkin.name;
            const skinIndex = index;
            const skinContainer = this.funkySkinContainer;

            var skin = new Skin(skinName, skinIndex, skinContainer);
            this.funkySkinList.push(skin);
        }

        this.funkyExplicationText = new PIXI.Text(LocaleManager.words.funkyTutorial, explicationTextStyle);
        this.funkyExplicationText.anchor.set(0.5, 1);
        this.funkyExplicationText.x = 0;
        this.funkyExplicationText.y = -130;
        this.funkySkinContainer.addChild(this.funkyExplicationText);

        this.funkySkinWatchAdButton = new PIXI.Sprite(greenButtonTexture);
        this.funkySkinWatchAdButton.interactive = true;
        this.funkySkinWatchAdButton.buttonMode = true;
        this.funkySkinWatchAdButton.on("pointerdown", this.onClickWatchAdFunky);
        this.funkySkinWatchAdButton.scale.set(0.5, 0.35);
        this.funkySkinWatchAdButton.anchor.set(0.5, 1);
        this.funkySkinWatchAdButton.x = 0;
        this.funkySkinWatchAdButton.y = -50;
        this.funkySkinContainer.addChild(this.funkySkinWatchAdButton);

        var playIcon = new PIXI.Sprite(playIconTexture);
        playIcon.scale.set(0.05);
        playIcon.anchor.set(0, 1);
        playIcon.x = 0;
        playIcon.y = -75;
        this.funkySkinContainer.addChild(playIcon);

        var funkyButtonText = new PIXI.Text(LocaleManager.words.unlock1, funkySkinButtonStyle);
        funkyButtonText.anchor.set(0.5, 1);
        funkyButtonText.scale.set(0.85);
        funkyButtonText.x = 0;
        funkyButtonText.y = -90;
        this.funkySkinContainer.addChild(funkyButtonText);

        this.rarityTabList[2].tabContainer = this.funkySkinContainer;



        // Change the skin shop container state according to the isSkinShopOpen
        if (this.isSkinShopOpen) {
            this.skinShopContainer.scale.set(1);
        }
        else {
            this.skinShopContainer.scale.set(0);
        }

        // Update the rarity button once
        this.updateRarityButton();

        gsap.delayedCall(0.1, () => {

            let interval = setInterval(() => {

                if (GameManager.PURCHASED_SKINS) {
                    interval && clearInterval(interval);
                    this.updateSkinPurchased();
                }

            }, 60);

        });
    }

    resize(w, h, coef) {

        // Resize the button open skin shop
        this.buttonOpenSkinShop.x = 130;
        this.buttonOpenSkinShop.y =  194;

        // Resize the skin shop container
        this.skinShopContainer.x = w / 2;
        this.skinShopContainer.y = h - 34;

        if (this.isSkinShopOpen) {
            if (coef <= .9) {
                this.skinShopContainer.scale.set(coef);
            } else {
                this.skinShopContainer.scale.set(.9);
            }
        }

        this.skinShopContainerScale = this.skinShopContainer.scale.x;


        // Resize the skin shop background        
        this.skinShopBackground.height = this.skinShopHeight + 34;
        this.skinShopBackground.y = 38;

        this.skinShopBackground.width = this.skinShopHeight;

        // Resize the close button
        this.buttonCloseSkinShop.y = -this.skinShopHeight + 32;
        this.buttonCloseSkinShop.x = w / 2 < 250 ? (w / 2 + this.buttonCloseSkinShop.width / 2) : 250;

        // Resize the left button
        this.leftButton.x = - 140;
        this.leftButton.y = -this.skinShopHeight + 40;

        // Resize the right button
        this.rightButton.x = 140;
        this.rightButton.y = -this.skinShopHeight + 40;

        // Resize the rarity background
        this.rarityBackground.x = 0;
        this.rarityBackground.y = -this.skinShopHeight + 63;


    }

    onClickOpenSkinShop() {

        config.skinOpen = true;
        //GameManager.H5SDK.getPlatform().getAdsModule().requestBannerAd();
        this.lockRVButton = false;

        gsap.fromTo(this.skinShopContainer.scale, { x: 0, y: 0 }, { x: .9, y: .9, duration: 0.3 });


        let interval = setInterval(() => {

            if (GameManager.PURCHASED_SKINS) {
                interval && clearInterval(interval);
                this.updateSkinPurchased();
            }

        }, 60);

    }

    updateSkinPurchased() {
        // Load the information from the Game manager
        var purchasedSkinsNameList = GameManager.PURCHASED_SKINS;

        // if (GameManager.GAME.isDebug) {
        //     purchasedSkinsNameList = ["ChickenBucket", "Shield", "HumanEye", "Basketball", "Shield", "LegoHead", "Football", "Beachball", "DinoEgg", "Barrel", "Powerball", "Mandalorian", "Baseball", "Planet", "Smiley", "Minion", "Mushroom", "Gyroscope", "Cube", "Pacman", "Gem", "Fish", "Pokeball", "Chest", "RubberDuck", "Pumpkin", "Bottle", "Apple", "SprinkleBall", "Spiral", "Frame", "Rainbow", "Star", "Skull", "MoonMeteor", "Gear", "Fog", "Teddy", "Wheel", "Heart", "Steve", "Tennisball", "Volleyball", "Bone", "Dice", "Shoe"]
        // }

        // For the funky skin
        this.funkySkinUnpurchasedList = [];
        for (let index = 0; index < this.funkySkinList.length; index++) {
            const funkySkin = this.funkySkinList[index];

            if (purchasedSkinsNameList.includes(funkySkin.skinName)) {
                funkySkin.enableSelection();
            }
            else {
                this.funkySkinUnpurchasedList.push(funkySkin);
            }
        }

        if (this.funkySkinUnpurchasedList.length == 0) {
            this.funkySkinWatchAdButton.visible = false;
            this.funkyExplicationText.visible = false;
        }

        // Check if the user has some old skins
        for (let index = 0; index < GameConfig.oldSkinNameList.length; index++) {
            const oldSkinName = GameConfig.oldSkinNameList[index];

            if (purchasedSkinsNameList.includes(oldSkinName)) {
                // Delete the old skin
                purchasedSkinsNameList.splice(purchasedSkinsNameList.indexOf(oldSkinName), 1);

                // Give the player a funky skin
                this.unlockFunkySkin();

                purchasedSkinsNameList = GameManager.PURCHASED_SKINS;
            }
        }

        // For the basic skins
        this.basicSkinUnpurchasedList = [];
        for (let index = 0; index < this.basicSkinList.length; index++) {
            const basicSkin = this.basicSkinList[index];

            if (purchasedSkinsNameList.includes(basicSkin.skinName)) {
                basicSkin.enableSelection();
            }
            else {
                this.basicSkinUnpurchasedList.push(basicSkin);
            }
        }

        // For the rare skins
        this.rareSkinUnpurchasedList = [];
        for (let index = 0; index < this.rareSkinList.length; index++) {
            const rareSkin = this.rareSkinList[index];

            if (purchasedSkinsNameList.includes(rareSkin.skinName)) {
                rareSkin.enableSelection();
            }
            else {
                this.rareSkinUnpurchasedList.push(rareSkin);
            }
        }


        // Update the price of the skin in each pages
        this.updateSkinPrice();

        this.updateCoin(GameManager.COIN);
    }

    onClickCloseSkinShop() {
        gsap.fromTo(this.skinShopContainer.scale, { x: 1, y: 1 }, {
            x: 0, y: 0, duration: 0.3, onComplete: () => {
                config.skinOpen = false;
            }
        });
       // GameManager.H5SDK.getPlatform().getAdsModule().hideBanner();
       // GameManager.H5SDK.getPlatform().getModule("AdReloadModule").clean({name:"Banner", id:6});
    }

    onClickLeftButton() {
        if (this.rarityTabIndex == 0) {
            this.rarityTabIndex = this.rarityTabList.length - 1;
            this.updateRarityButton();
        }
        else {
            this.rarityTabIndex -= 1;
            this.updateRarityButton();
        }
    }

    onClickRightButton() {
        if (this.rarityTabIndex == this.rarityTabList.length - 1) {
            this.rarityTabIndex = 0;
            this.updateRarityButton();
        }
        else {
            this.rarityTabIndex += 1;
            this.updateRarityButton();
        }
    }

    onClickBasicPurchase() {
        if (GameManager.COIN >= this.basicSkinPurchasePrice && this.basicSkinUnpurchasedList.length != 0) {
            // Purchase skin and save once
            GameManager.COIN -= this.basicSkinPurchasePrice;
            const purchaseSkinIndex = Tools.randomNum(0, this.basicSkinUnpurchasedList.length - 1);
            GameManager.PURCHASED_SKINS.push(this.basicSkinUnpurchasedList[purchaseSkinIndex].skinName);
            GameManager.uploadPlayerData();

            // Update the price of the skin in each pages
            this.updateSkinPrice();

            // Blink animation
            const numberOfBlink = this.basicSkinUnpurchasedList.length;
            for (let index = 0; index < numberOfBlink; index++) {
                gsap.delayedCall(index * 0.2, () => {
                    const randomNum = Tools.randomNum(0, this.basicSkinUnpurchasedList.length - 1);
                    this.basicSkinUnpurchasedList[randomNum].blinkSelection();
                });
            }

            gsap.delayedCall(numberOfBlink * 0.2, () => {
                this.basicSkinUnpurchasedList[purchaseSkinIndex].enableSelection();
                this.basicSkinUnpurchasedList.splice(purchaseSkinIndex, 1);
            });
        }
        else {
            // Informe not enough money
            GameManager.notEnoughCoin();
        }
    }

    onClickRarePurchase() {
        if (GameManager.COIN >= this.rareSkinPurchasePrice && this.rareSkinUnpurchasedList.length != 0) {
            // Purchase skin and save once
            GameManager.COIN -= this.rareSkinPurchasePrice;
            const purchaseSkinIndex = Tools.randomNum(0, this.rareSkinUnpurchasedList.length - 1);
            GameManager.PURCHASED_SKINS.push(this.rareSkinUnpurchasedList[purchaseSkinIndex].skinName);
            GameManager.uploadPlayerData();

            // Update the price of the skin in each pages
            this.updateSkinPrice();

            // Blink animation
            const numberOfBlink = this.rareSkinUnpurchasedList.length;
            for (let index = 0; index < numberOfBlink; index++) {
                gsap.delayedCall(index * 0.2, () => {
                    const randomNum = Tools.randomNum(0, this.rareSkinUnpurchasedList.length - 1);
                    this.rareSkinUnpurchasedList[randomNum].blinkSelection();
                });
            }

            gsap.delayedCall(numberOfBlink * 0.2, () => {
                this.rareSkinUnpurchasedList[purchaseSkinIndex].enableSelection();
                this.rareSkinUnpurchasedList.splice(purchaseSkinIndex, 1);
            });
        }
        else {
            // Informe not enough money
            GameManager.notEnoughCoin();
        }
    }

    onClickWatchAdAddCoin() {
        console.log("Click RV -------------------");
        if(this.lockRVButton) return;
        this.lockRVButton = true;
        this.requestRewarded((result) => {
            console.log("reponse RV -------------------");
            if (result) {
                // Player finish the ad
                GameManager.COIN += 500;
                // Save the current skin on the SDK
                GameManager.uploadPlayerData();
            }
            else {
                // Player skip the ad

            }
            this.lockRVButton = false;
        });
    }

    onClickWatchAdFunky() {
        if(this.lockRVButton) return;
        this.lockRVButton = true;
        if (this.funkySkinUnpurchasedList.length != 0) {
            this.requestRewarded((result) => {
                if (result) {
                    this.unlockFunkySkin();
                }
                else {
                    // Player skip the ad
                }
                this.lockRVButton = false;
            });
        }
    }

    unlockFunkySkin() {
        // Player finish the ad
        if (this.funkySkinUnpurchasedList.length != 0) {
            const purchaseSkinIndex = Tools.randomNum(0, this.funkySkinUnpurchasedList.length - 1);
            GameManager.PURCHASED_SKINS.push(this.funkySkinUnpurchasedList[purchaseSkinIndex].skinName);
            GameManager.uploadPlayerData();

            // Blink animation
            const numberOfBlink = this.funkySkinUnpurchasedList.length;
            for (let index = 0; index < numberOfBlink; index++) {
                gsap.delayedCall(index * 0.2, () => {
                    const randomNum = Tools.randomNum(0, this.funkySkinUnpurchasedList.length - 1);
                    this.funkySkinUnpurchasedList[randomNum].blinkSelection();
                });
            }

            gsap.delayedCall(numberOfBlink * 0.2, () => {
                this.funkySkinUnpurchasedList[purchaseSkinIndex].enableSelection();
                this.funkySkinUnpurchasedList.splice(purchaseSkinIndex, 1);
            });
        }
    }


    updateRarityButton() {
        const switchAnimationTime = 0.2;
        gsap.to(this.rarityButton, { x: this.rarityTabList[this.rarityTabIndex].positionX, duration: switchAnimationTime });
        gsap.to(this.rarityText, { x: this.rarityTabList[this.rarityTabIndex].positionX, duration: switchAnimationTime });
        this.rarityText.text = this.rarityTabList[this.rarityTabIndex].text;

        //console.log(this.basicSkinContainer);

        for (let index = 0; index < this.rarityTabList.length; index++) {
            const rarityTab = this.rarityTabList[index];
            if (index == this.rarityTabIndex) {
                // Show the corresponding rarity tab
                gsap.to(rarityTab.tabContainer.scale, { x: 1, y: 1, duration: 0.2 });
                //rarityTab.tabContainer.scale.set(1);
            }
            else {
                // Hide the rarity tab
                gsap.to(rarityTab.tabContainer.scale, { x: 0, y: 0, duration: 0.2 });
                //rarityTab.tabContainer.scale.set(0);
            }
        }
    }

    async requestRewarded(callback) {
        const result = await GameManager.H5SDK.getAdsModule().requestRewardedAd();
        callback(result);
    }

    updateSkinPrice() {
        // Load the information from the Game manager
        const purchasedSkinsNameList = GameManager.PURCHASED_SKINS;

        // For the basic skins
        var numberOfBasicSkinsPurchased = 0;

        for (let index = 0; index < this.basicSkinList.length; index++) {
            const basicSkin = this.basicSkinList[index];

            if (purchasedSkinsNameList.includes(basicSkin.skinName)) {
                numberOfBasicSkinsPurchased += 1;
            }
        }

        // For the rare skins
        var numberOfRareSkinsPurchased = 0;

        for (let index = 0; index < this.rareSkinList.length; index++) {
            const rareSkin = this.rareSkinList[index];

            if (purchasedSkinsNameList.includes(rareSkin.skinName)) {
                numberOfRareSkinsPurchased += 1;
            }
        }



        // Change the price for basic, rare, epic and chest skin
        const numTotalSkinsPurchased = numberOfBasicSkinsPurchased + numberOfRareSkinsPurchased;
        // const numTotalSkinsPurchased = numberOfBasicSkinsPurchased + numberOfRareSkinsPurchased + numberOfEpicSkinsPurchased + numberOfChestSkinsPurchased;
        this.basicSkinPurchasePrice = 100 + numTotalSkinsPurchased * 500;
        this.basicSkinPriceText.text = this.basicSkinPurchasePrice;

        this.rareSkinPurchasePrice = 100 + numTotalSkinsPurchased * 500;
        this.rareSkinPriceText.text = this.rareSkinPurchasePrice;


    }

    changeSkin(skinName) {
        // Deselect all the skin named differently than the skinName
        for (let index = 0; index < this.basicSkinList.length; index++) {
            const element = this.basicSkinList[index];
            if (element.skinName == skinName) {
                config.currentSkin = skinName;
                element.selectSkin();
            }
            else {
                element.deselectSkin();
            }
        }

        for (let index = 0; index < this.rareSkinList.length; index++) {
            const element = this.rareSkinList[index];
            if (element.skinName == skinName) {
                config.currentSkin = skinName;
                element.selectSkin();
            }
            else {
                element.deselectSkin();
            }
        }

        for (let index = 0; index < this.funkySkinList.length; index++) {
            const element = this.funkySkinList[index];
            if (element.skinName == skinName) {
                config.currentSkin = skinName;
                element.selectSkin();
            }
            else {
                element.deselectSkin();
            }
        }


    }

    updateCoin(coin) {
        if (coin >= this.basicSkinPurchasePrice) {
            this.alertSkinShop.visible = true;
            this.basicSkinPurchaseButton.texture = this.blueButtonTexture;
            this.rareSkinPurchaseButton.texture = this.blueButtonTexture;
        }
        else {
            this.alertSkinShop.visible = false;
            this.basicSkinPurchaseButton.texture = this.greyButtonTexture;
            this.rareSkinPurchaseButton.texture = this.greyButtonTexture;
        }
    }

    notifyLevelStart() {
        // Hide the buttonOpenSkinShop
        this.buttonOpenSkinShop.visible = false;
        this.alertSkinShop.visible = false;
        this.basicSkinPurchaseButton.texture = this.greyButtonTexture;
        this.rareSkinPurchaseButton.texture = this.greyButtonTexture;
        if (GameManager.GAME.isDebug) {
            this.buttonOpenSkinShop.visible = true;
        }
    }

    restart() {
        // Show the buttonOpenSkinShop
        this.buttonOpenSkinShop.visible = true;
    }
}